//# sourceMappingURL=my-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-options.interface.js
// module id = 574
// module chunks = 10